<template>
  <layout-main-inner title="发货管理">
    <layout-card-wrap :hasSlot="true">
      <template slot="form">
        <!-- <ent-auto-select
          v-model="config.vendorId"
          style="margin-right: 10px"
          :callback="()=> { handleCurrentChange(1) }" /> -->
        <el-input
          v-model="config.outstockCode"
          clearable
          style="width: 240px"
          placeholder="请输入出库单号"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="出库单号"
          width="160"
          prop="outstockCode"> </el-table-column>
        <el-table-column
          label="订单号"
          width="160"
          prop="orderNumber"> </el-table-column>
        <el-table-column
          label="商品名称"
          min-width="200"
          prop="productNames"> </el-table-column>
        <el-table-column
          label="企业名称"
          min-width="160"
          prop="vendorName">
        </el-table-column>
        <el-table-column
          label="出库数量"
          width="100"
          prop="outGoodsCount">
          <template slot-scope="{ row }">
            <el-popover
              v-model="row.visible"
              title="出库明细"
              placement="left"
              trigger="manual">
              <el-table
                border=""
                :data="gridData">
                <el-table-column
                  width="150"
                  property="productName"
                  label="商品名称"></el-table-column>
                <el-table-column
                  width="100"
                  property="outGoodsCount"
                  label="数量"></el-table-column>
              </el-table>
              <div style="text-align: right; margin-top: 5px">
                <el-button
                  @click="row.visible = false">关闭</el-button>
              </div>
              <el-link
                slot="reference"
                style="font-size: 12px"
                type="primary"
                @click="togglePop(row)">{{ row.outGoodsCount }}</el-link>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="出库时间"
          width="140"
          prop="outstockTime">
          <template slot-scope="{ row }">
            {{ row.outstockTime | dateformat() }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange">
      </el-pagination>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
// import EntAutoSelect from '../../components/ent-auto-select.vue'
export default {
  name: 'ScmOutstocks',
  components: { },
  data() {
    return {
      loading: true,
      gridData: [],
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        outstockCode: '',
        vendorId: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    togglePop(row) {
      if (row.visible) {
        row.visible = false
      } else {
        this.loading = true
        this.$store.dispatch('zs/getoutstock', {
          payload: {
            outstockId: row.outstockId,
            vendorId: row.vendorId
          },
          success: (res) => {
            this.loading = false
            this.gridData = res.data.outstockItems
            row.visible = true
          },
          fail: () => {
            this.loading = false
          }
        })
      }
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('zs/getoutstocks', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records.map(i => {
            return {
              ...i,
              visible: false
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
